import { HelpCenter, PublicLocale } from "../../../types";

export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const SET_LOCALE = "SET_LOCALE";

export interface HelpCenterState {
  currentLocale: PublicLocale;
  helpCenter: HelpCenter;
  customDomainEnabled: boolean;
}

export interface SetInitialStateAction {
  type: typeof SET_INITIAL_STATE;
  helpCenter: HelpCenter;
}

interface SetLocaleAction {
  type: typeof SET_LOCALE;
  locale: PublicLocale;
}

export type HelpCenterActionTypes = SetInitialStateAction | SetLocaleAction;
